/* eslint-disable @typescript-eslint/naming-convention */

'use client';

import Grid from '@gds/Grid/Grid';

import { GalleryContainerProps } from './Gallery.entity';
import GalleryHeader from './GalleryHeader/GalleryHeader';

import styles from './Gallery.module.css';

const GalleryContainer = ({
  images,
  galleryStrings,
  locale,
  children,
  currentIndex,
  step,
  setStep,
  onBackButtonClick,
}: GalleryContainerProps) => {
  const { backButton } = galleryStrings;
  const totalImgs = images.length;

  const handleBackButtonClick = () => {
    if (typeof onBackButtonClick === 'function') {
      onBackButtonClick();
      return;
    }
    setStep(step - 1);
    window.history.back();
  };

  return (
    <section className={styles.container}>
      <Grid.Container
        className={`${styles.gridContainer} ${step === 1 ? styles.patchWorkGalleryContainer : ''}`}
      >
        <GalleryHeader
          props={{
            onClick: handleBackButtonClick,
            ctaText: backButton,
            sliderCounter: currentIndex,
            totalImgs,
            step,
          }}
          locale={locale}
        />
        {children}
      </Grid.Container>
    </section>
  );
};

export default GalleryContainer;
